// Tiny inline-SVG sparkline. No external chart library.
// used on the KPIs list, KPI detail and the dashboard snapshot card.

export default function Sparkline({
  points = [],
  width = 100,
  height = 28,
  stroke = "#2563EB",
  fill = "#DBE7FE",
  showDots = false,
  testid,
}) {
  if (!points || points.length === 0) {
    return <span data-testid={testid} className="text-[11px] text-[#4B5773]">-</span>;
  }
  const nums = points.map((p) => (typeof p === "number" ? p : p.value)).filter((n) => n != null);
  if (nums.length === 0) {
    return <span data-testid={testid} className="text-[11px] text-[#4B5773]">-</span>;
  }
  const min = Math.min(...nums);
  const max = Math.max(...nums);
  const span = (max - min) || 1;
  const step = nums.length > 1 ? width / (nums.length - 1) : 0;
  const yFor = (n) => height - ((n - min) / span) * (height - 4) - 2;
  const path = nums.map((n, i) => `${i === 0 ? "M" : "L"} ${(i * step).toFixed(2)} ${yFor(n).toFixed(2)}`).join(" ");
  const area = `${path} L ${(width).toFixed(2)} ${height} L 0 ${height} Z`;
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}
      data-testid={testid}
      role="img" aria-label="trend">
      <path d={area} fill={fill} opacity="0.4" />
      <path d={path} fill="none" stroke={stroke} strokeWidth="1.5"
        strokeLinecap="round" strokeLinejoin="round" />
      {showDots && nums.map((n, i) => (
        <circle key={i} cx={i * step} cy={yFor(n)} r="1.8" fill={stroke} />
      ))}
    </svg>
  );
}
